<template>
  <div
    :class="{
      'sub-title-center': select === true,
      'sub-title-left': select === false
    }"
  >
    <span class="title">{{ text }}</span>
    <span class="title-line" />
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  name: 'sub-title',
  components: {
  },
  props: {
    text: {
      type: String,
      default: '开发数据'
    },
    select: VueTypes.bool.def(true)
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.sub-title-center {
  display: flex; flex-direction: column; align-items: center; justify-content: center;

  @include mobile {
    align-items: flex-start;
  }
}

.sub-title-left {
  display: flex; flex-direction: column;
  width: 370px;
}

.title {
  margin-bottom: 10px;
  color: #000000;
  font-size: 36px; font-family: Alibaba-PuHuiTi-Heavy;
  line-height: 50px;

  @include mobile {
    margin-bottom: 4px;
    color: #000000;
    font-size: 20px; font-family: Alibaba-PuHuiTi-Heavy;
    line-height: 27px;
  }
}

.title-line {
  width: 70px; height: 6px;
  margin-bottom: 40px;
  background: #DE3640;

  @include mobile {
    width: 38px; height: 3px;
    margin-bottom: 16px;
    background: #DE3640;
  }
}
</style>
